<template functional>
  <h1
    class="LmTitle relative leading-tight"
    :class="[
      props.color,
      data.class,
      data.staticClass,
      {
        'text-base': props.size === 'm',
        'text-l': props.size === 'l',
        'text-xl': props.size === 'xl',
        'text-xxl': props.size === 'xxl',
        'cursor-pointer hover:text-gray-500': props.clickable,
        'is-new': props.isNew
      }
    ]"
    v-on="data.on"
  >
    <slot />
  </h1>
</template>

<script>
export default {
  name: 'LmTitle',
  props: {
    size: {
      validator(value) {
        return ['m', 'l', 'xl', 'xxl'].indexOf(value) !== -1
      },
      default: 'l'
    },
    clickable: {
      type: Boolean,
      default: false
    },
    isNew: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'text-gray-900'
    }
  }
}
</script>

<style scoped>
.LmTitle.is-new:before {
  content: '';
  position: absolute;
  top: 7px;
  left: -12px;
  width: 7px;
  height: 7px;
  background-color: theme('colors.highlight');
  border-radius: 100%;
  @media (--desktop) {
    left: -16px;
  }
}
</style>
